export default "__VITE_ASSET__Bnb8GBYh__"